export enum SubUrlsEnum {
    // AUTH
    LOGIN = 'users/sign_in',
    REFRESH_TOKEN = 'users/tokens',
    LOGOUT = 'users/sign_out',
    RESET_PWD = 'users/reset_password',
    CREATE_PWD = 'users/generate_password',
    RECOVERY_PWD = 'users/recovery',

    // MESSAGING
    MESSAGE = 'message',
    MESSAGES = 'messages',
    MESSAGE_VIEWED = 'message/viewed',
    MESSAGE_ARCHIVED = 'message/archived',
    MSG_RECEIVED = 'messages/received',
    MSG_SENDED = 'messages',
    MSG_DELETED = 'messages/deleted',
    SEARCH_CONTACTS = 'users/messaging_search',
    UNARCHIVE = 'messages/',
    UNREAD_MESSAGES_COUNT = 'messages/unread',

    // USERS
    ADMINISTRATORS = 'administrators',
    ADMINISTRATOR = 'administrator',
    USERS = 'users',
    USER = 'user/',
    MYUSER = 'users/me',
    EMPLOYEES = 'employees',
    PARENTS = 'parents',
    STUDENTS = 'students',
    RELATIVES = 'relatives',
    CONTACTS = 'contacts',
    STATUS = 'status',
    USERS_REPERTOIRE = 'users/light',
    MY_ACCOUNT = 'users/profile',
    PARENT_IN_CHARGE = 'students/{{studentId}}/responsable_parent',

    // ENTITIES
    SCHOOLS = 'schools',
    SCHOOL = 'schools/',
    CLASSES = 'school_classes',
    CLASS = 'classes/',
    GROUPS = 'groups',
    GROUP = 'groups/',
    SCHOOL_SIGNATURE = 'schools/{{id}}/trd_signature',

    // DATA
    SCHOOL_YEARS = 'school_years',

    // ENUMS
    ROLES = 'roles',
    GENDERS = 'genders',
    EDUCATION_LEVELS = 'education_levels',
    EDUCATION_TYPES = 'education_types',
    COSTS_REPARTITION = 'costs_repartitions',
    CLASS_TYPES = 'school_class_types',
    RATE_TYPES = 'rate_types',
    CUSTODY_TYPES = 'custody_types',
    RELATIVE_TYPES = 'relative_types',
    CONTACT_TYPES = 'contact_types',
    CREDIT_TYPES = 'credit_types',
    DEBIT_TYPES = 'debit_types',
    STORAGE_TYPES = 'storage_types',

    // STORE
    WALLET_PAY = 'wallet_pay',
    WALLET_CHARGE = 'wallet_charge',
    WALLET_WITHDRAW = 'wallet_withdraw',
    MEAL_ORDERS = 'meal_orders',
    TRANSACTIONS = 'transactions',

    // WALLET
    WALLET = 'wallet',
    WALLETS = 'wallets',
    CREDITS = 'credits',
    DEBITS = 'debits',
    UNLOAD_WALLET = 'parents/{{parent_id}}/unload_wallet',
    TRANSFER_MONEY = 'wallets/transfer',
    LOAD_CLASS_WALLET = 'credits/load_class_wallet',
    UNLOAD_CLASS_WALLET = 'debits/unload_class_wallet',
    CANCEL_PAYMENT_ITEM = 'debits/payment_items',
    WALLETS_TRANSACTIONS = 'wallets/transactions',
    EXPORT_TAX_RETURN_CSV = 'export/tax_return_documents',
    EXPORT_TAX_RETURN_PDF = 'export/tax_return_documents_pdf',

    // MEALS
    MEAL_SETTINGS = 'meal_settings',
    AVAILABLE_MEALS = 'schools/{{schoolId}}/meals',
    ACTIVATE_MEALS = 'schools/{{schoolId}}/meals/activate',
    DISABLE_MEALS = 'schools/{{schoolId}}/meals/disable',
    DISABLE_MONTH_MEALS = 'schools/{{schoolId}}/meals/disable_month',
    BOOK_MEALS = 'book_meals',
    CANCEL_BOOK_MEALS = 'book_meals/cancel',
    MEAL_FILE = 'schools/{{schoolId}}/meal_files',
    BOOKED_MEALS_BY_MONTH = 'book_meals/by_month',
    BOOKED_MEALS_BETWEEN_DATE = 'book_meals',

    // NURSERY
    NURSERY = 'pointings',
    NURSERY_ADD = 'pointings',
    NURSERY_SETTINGS = 'schools/{{school_id}}/pointing_settings',
    NUSERY_UPDATE_SETTINGS = 'pointing_settings/{{pointing_setting_id}}',
    NURSERY_SORTED_STUDENTS = 'students/pointings',
    NURSERY_DELETE = 'pointings/{{pointing_id}}',
    NURSERY_POINTINGS_BY_MONTH = 'pointings/by_month',

    // HOMEWORK_SCHOOL
    HOMEWORK_SETTINGS = 'homework_settings',
    AVAILABLE_HOMEWORK = 'schools/{{schoolId}}/homeworks',
    ACTIVATE_HOMEWORK = 'schools/{{schoolId}}/homeworks/activate',
    DISABLE_HOMEWORK = 'schools/{{schoolId}}/homeworks/disable',
    DISABLE_MONTH_HOMEWORK = 'schools/{{schoolId}}/homeworks/disable_month',
    BOOK_HOMEWORK = 'book_homeworks',
    BOOK_HOMEWORK_BY_MONTH = 'book_homeworks/by_month',
    CANCEL_BOOK_HOMEWORK = 'book_homeworks/cancel',

    // SUPPORT
    SUPPORT = 'bugs',

    // STRIPE
    PAYMENT_INTENT = 'stripe/payment_intent',

    // EXPORTS
    EXPORT_MEALS = 'export/meals',
    EXPORT_HOMEWORKS = 'export/homeworks',
    EXPORT_POINTINGS = 'export/pointings',
    EXPORT_WALLETS = 'export/wallets',

    // IMPORTS
    IMPORT_USERS = 'import/users',
    IMPORT_WALLET = 'import/wallets',

    // CLOUD
    BASE_FOLDERS = 'folders',
    FOLDER = 'folders/{{folderId}}',
    CREATE_FOLDER = 'folders/{{folderId}}/folder',
    FILES = 'folders/{{folderId}}/items',
    FILE = 'folders/{{folderId}}/items/{{itemId}}',
    SEARCH_FILES = 'folders/search',

    // MIGRATE
    MIGRATE = 'schools/{{id_school}}/migrate',
    ASSIGN_CLASSES = 'schools/{{id_school}}/assign_students',
}
